export const CODE_STATE = {
  INVALID: "invalid", // Code isn't invalid/doesn't exist
  DUPLICATE: "duplicate", // Code has already been awarded
  FAILED: "failed", // Code not awarded due to questions not answered correctly
  AWARDED: "awarded" // Code has been awarded
};

export const TIME_FILTERS = {
  ALL_TIME: "all-time",
  WEEKLY: "weekly"
};

export const LEADERBOARD_FILTERS = {
  INDIVIDUAL: "individual",
  GROUPS: "groups"
};

export const DEFAULT_SELECT_VALUE = {
  STUDENT: "Select a student",
  ACHIEVEMENT: "Select an achievement"
};
